import { IKishuListVM } from '../../models/response/IKishuResponse';
const initialKishuState: IKishuListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  KishuMarks: [],
};

export default initialKishuState;
